import { render, staticRenderFns } from "./QuickIntro.vue?vue&type=template&id=17841928&scoped=true&"
import script from "./QuickIntro.vue?vue&type=script&lang=js&"
export * from "./QuickIntro.vue?vue&type=script&lang=js&"
import style0 from "./QuickIntro.vue?vue&type=style&index=0&id=17841928&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=17841928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17841928",
  null
  
)

export default component.exports